/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { ICON_PLACEMENT } from '../../globals/defs.js';
export { default as CustomElement } from '../../components/link-with-icon/link-with-icon.js';
import createReactCustomElementType, {
  booleanSerializer,
} from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = {
  ctaType: {
    attribute: 'cta-type',
  },
  iconPlacement: {
    attribute: 'icon-placement',
  },
  iconInline: {
    serialize: booleanSerializer,
  },
  size: {},
};
export var propTypes = {
  ctaType: PropTypes.string,
  /**
   * Icon placement(right (default) | left)
   */
  iconPlacement: PropTypes.string,
  /**
   * Positions the icon inline with text when `true`
   */
  iconInline: PropTypes.bool,
  /**
   * Property that specifies the link to use size large
   *
   * @internal
   */
  size: PropTypes.string,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-link-with-icon'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
